import { render, staticRenderFns } from "./SurwayComponent.vue?vue&type=template&id=0b47e487&scoped=true"
import script from "./SurwayComponent.vue?vue&type=script&lang=js"
export * from "./SurwayComponent.vue?vue&type=script&lang=js"
import style1 from "./SurwayComponent.vue?vue&type=style&index=1&id=0b47e487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47e487",
  null
  
)

export default component.exports